<template>
  <div
      v-if="isShow"
      class="login"
      @touchmove.prevent>
      <div class="login-box">
        <!-- <van-icon name="cross" @click="isShow=false"></van-icon> -->
        <div class="commit"><p>您有咨询订单尚未付款</p>为了不影响您的后续使用请付款</div>
        <div class="button">
          <!-- <div class="close" @click="isShow=false">取消</div> -->
          <div class="confirm" @click="submit">确定</div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return{
      isShow: false,
    }
  },
  methods: {
    open() {
      this.isShow = true
    },
    submit() {
      this.isShow = false
      this.$router.push({path: '/OrderList', query: {index: '1'}})
    }
  }
}
</script>

<style lang="scss" scoped>
.login{
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2011;
  text-align: center;
}
.login-box {
  background: #fff;
  box-sizing: border-box;
  padding-top:0;
  width: 300px;
  height: 180px;
  margin: 0 auto;
  margin-top: 45%;
  border-radius: 8px;
  position: relative;
  font-size: 18px;
  color: #666666;
  >i{
    position: absolute;
    font-size: 18px;
    top: 16px;
    right: 16px;
    color: #999999;
  }
  .commit{
    padding-top: 30px;
  }
  .cross-time{
    color: #333333;
    padding-top: 5px;
  }
  .button{
    margin-top: 30px;
    >div{
      display: inline-block;
      border-radius: 22px;
      line-height: 40px;
      text-align: center;
      box-sizing: border-box;
      width: 115px;
      height: 40px;
    }
    .close{
      border: 1px solid #CCCCCC;
    }
    .confirm{
      background: linear-gradient(90deg, #EBD2A8 0%, #E9BA66 100%);
      color: #402200;
      margin-left: $padding;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/LjbNotpay.vue